import dayjs from 'dayjs';

import { IUser } from 'app/shared/model/user.model';

export interface ICliente {
  id?: number;
  key?: string | null;
  nombre?: string;
  cuentaBancaria?: string;
  claveInstitucion?: string;
  tipoCuenta?: number;
  numeroCertificado?: string;
  aliasCertificado?: string;
  digitoVerificador?: string;
  pagoComision?: number;
  tipoPago?: number;
  keySource?: string;
  keyPem?: string;
  certificadoPem?: string;
  extra1?: string | null;
  extra2?: string | null;
  extra3?: string | null;
  extra4?: string | null;
  extra5?: string | null;
  extra6?: string | null;
  extra7?: string | null;
  extra8?: string | null;
  extra9?: string | null;
  extra10?: string | null;
  createdBy?: string | null;
  createdDate?: dayjs.Dayjs | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: dayjs.Dayjs | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<ICliente> = {};
